import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  activeCollapseData: {},
  makeCallData: {
    number: "",
    callDirection: "",
    dialingcode: "",
    myNumber: ""
  },
  activeCallLog: {},
  activeNumber: {},
  activeDialerLog: {},
  dtmf: "",
  media: {}
}
export const sliceKey = "activeCollapse"

export const activeCollapseSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setActiveCollapse: (state, { payload }) => {
      try {
        state.activeCollapseData = payload
      } catch (e) {
        console.log(e)
      }
    },
    setMakeCallData: (state, { payload }) => {
      try {
        state.makeCallData = payload
      } catch (e) {
        console.log(e)
      }
    },
    setActiveCallLog: (state, { payload }) => {
      try {
        state.activeCallLog = payload
      } catch (e) {
        console.log(e)
      }
    },
    setActiveNumber: (state, { payload }) => {
      try {
        state.activeNumber = payload
      } catch (e) {
        console.log(e)
      }
    },
    setActiveDialerLog: (state, { payload }) => {
      try {
        state.activeDialerLog = payload
      } catch (e) {
        console.log(e)
      }
    },
    setDtmlNumber: (state, { payload }) => {
      try {
        state.dtmf = payload
      } catch (e) {
        console.log(e)
      }
    },
    setMedia: (state, { payload }) => {
      try {
        state.media = payload
      } catch (e) {
        console.log(e)
      }
    },
    setIsDetailPage: (state, { payload }) => {
      try {
        state.isDetailPage = payload
      } catch (e) {
        console.log(e)
      }
    }
  }
})

export const {
  setActiveCollapse,
  setMakeCallData,
  setActiveCallLog,
  setActiveNumber,
  setActiveDialerLog,
  setDtmlNumber,
  setMedia,
  setIsDetailPage
} = activeCollapseSlice.actions

export default activeCollapseSlice.reducer
